import {Summary} from './summary';

export class EquipmentCategory {
	readonly slug: string;
	get nextCategory(): EquipmentCategory|null {
		return this._nextCategory;
	}
	get disabled(): boolean {
		return this._disabled;
	}
	set nextCategory(value: EquipmentCategory) {
		this._nextCategory = value;
	}

	private readonly id: number;
	private wrapper : HTMLDivElement;
	private row: HTMLTableRowElement;
	private mobileRow: HTMLTableRowElement;
	private selectedPrice: number;
	private readonly optionCells: NodeListOf<HTMLTableCellElement>;
	private selectedAbsolutePrice: HTMLDivElement;
	private selectedPriceDiff: HTMLDivElement;
	private openTriggers = new Set<HTMLElement>;
	private labels: Set<HTMLLabelElement> = new Set;
	private summary: Summary;

	private _nextCategory : EquipmentCategory|null = null;

	private _disabled : boolean = false;

	private listenersSelect = new Set<(price:number) => void>();

	constructor(
		wrapper: HTMLDivElement,
		row : HTMLTableRowElement,
		summary: Summary,
	) {
		this.summary = summary;
		this.wrapper = wrapper;
		this.row = row;
		this.id = parseInt(row.dataset.id);
		this.slug = row.dataset.slug;
		this.selectedPrice = parseFloat(row.dataset.selected ?? '0')
		this.mobileRow = wrapper.querySelector<HTMLTableRowElement>(`.equipment-category-mobile[data-id="${this.id}"]`);

		this.optionCells = row.querySelectorAll<HTMLTableCellElement>('.option:not(.empty)');
		this.selectedAbsolutePrice = row.querySelector<HTMLDivElement>('.price .absolute-price');
		this.selectedPriceDiff = row.querySelector<HTMLDivElement>('.price .price-diff');
		for (const trigger of row.querySelectorAll<HTMLElement>('.closed, th, .empty')) {
			this.openTriggers.add(trigger);
		}
		for (const trigger of this.mobileRow.querySelectorAll<HTMLElement>('.category-name')) {
			this.openTriggers.add(trigger);
		}

		// Find all labels
		for (const label of row.querySelectorAll<HTMLLabelElement>('label')) {
			this.labels.add(label);
		}
		for (const label of this.mobileRow.querySelectorAll<HTMLLabelElement>('label')) {
			this.labels.add(label);
		}

		this.init();
	}

	private init() : void {
		for (const label of this.labels) {
			label.addEventListener('click', e => {
				if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLAnchorElement || e.target instanceof SVGPathElement || e.target instanceof SVGElement) {
					return;
				}
				if (!this._nextCategory) {
					return;
				}

				// Show next category
				setTimeout(() => {
					let nextCategory = this._nextCategory;
					// Skip disabled categories
					while (nextCategory && nextCategory.disabled) {
						nextCategory = nextCategory.nextCategory;
					}
					if (nextCategory) {
						nextCategory.show();
					}
				}, 200);
			});
		}

		for (const optionCell of this.optionCells) {
			const optionCheck = optionCell.querySelector('input');
			const price = parseInt(optionCheck.value);
			optionCheck.addEventListener('change', () => {
				this.updateSelectedPrice(price);
				for (const optionCellOther of this.optionCells) {
					optionCellOther.classList.remove('selected');
				}
				optionCell.classList.add('selected');
				for (const callback of this.listenersSelect) {
					callback(price);
				}
			});
			optionCell.addEventListener('mouseenter', () => {
				this.updatePriceDiff(price);
			});
			optionCell.addEventListener('mouseleave', () => {
				this.updatePriceDiff(this.selectedPrice);
			});
		}

		for (const openTrigger of this.openTriggers) {
			openTrigger.addEventListener('click', () => {
				this.toggleShow();
			});
		}
	}

	checkPrice(value : number) : void {
		const input = this.row.querySelector<HTMLInputElement>(`input[value="${value}"]`);
		if (input) {
			input.checked = true;
			input.dispatchEvent(new Event('change'));
		}
	}

	disable() {
		this._disabled = true;
		this.row.style.display = 'none';
		this.mobileRow.style.display = 'none';
	}

	enable() {
		this._disabled = false;
		this.row.style.display = null;
		this.mobileRow.style.display = null;
	}

	isShowing() : boolean {
		return this.row.classList.contains('show');
	}

	toggleShow() : void {
		console.log('Toggle', this.id);

		this.hideOthers();

		// Toggle current row
		this.row.classList.toggle('show');
		if (this.isShowing()) {
			this.mobileRow.classList.add('show');
		}
		else {
			this.mobileRow.classList.remove('show');
		}
	}

	hideOthers() : void {
		for (const row of this.wrapper.querySelectorAll<HTMLTableRowElement>(`.equipment-category.show:not([data-id="${this.id}"]),.equipment-category-mobile.show:not([data-id="${this.id}"])`)) {
			if (row.dataset.id === this.row.dataset.id) {
				return;
			}
			console.log('Hide', row.dataset.id, this.row.dataset.id);
			row.classList.remove('show');
		}
	}

	show() : void {
		this.hideOthers();
		this.row.classList.add('show');
		this.mobileRow.classList.add('show');
	}

	hide() : void {
		this.row.classList.remove('show');
		this.mobileRow.classList.remove('show');
	}

	updateSelectedPrice(price: number)  {
		this.selectedPrice = price;
		this.selectedAbsolutePrice.innerText = price.toLocaleString(undefined, {style: 'currency', currency: 'CZK', maximumFractionDigits: 0});
		this.row.dispatchEvent(new CustomEvent('configurator-select', {detail: {name: this.row.dataset.slug, price: price}}));
		this.updatePriceDiff(price);
		this.summary.setPrice(this.id, this.selectedPrice).update();
	}

	updatePriceDiff(price: number) {
		if (price === this.selectedPrice) {
			this.selectedPriceDiff.innerText = '';
			return;
		}
		const diff = price - this.selectedPrice;
		this.selectedPriceDiff.innerText = '(' + (diff > 0 ? '+' : '') + diff.toLocaleString(undefined, {
			style: 'currency', currency: 'CZK', maximumFractionDigits: 0
		}) + ')';
	};

	addChangeListener(callback: (price: number) => void) {
		this.listenersSelect.add(callback);
	}
}
